var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('aside', {
    staticClass: "popup-form campaign-clients-popup",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "campaign-clients-title"
    }
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "back-button-wrapper pointer",
    attrs: {
      "type": "button",
      "aria-label": _vm.payload.closeLabel || 'Zavrieť registrácie kampane'
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1), _c('h2', {
    attrs: {
      "id": "campaign-clients-title"
    }
  }, [_vm._v(_vm._s(_vm.payload.title || 'Registrácie kampane'))])]), _c('h3', [_vm._v(_vm._s(_vm.payload.name))]), _c('p', {
    staticClass: "campaign-period"
  }, [_vm._v(_vm._s(_vm.payload.leads) + " registrácií · " + _vm._s(_vm.payload.days) + " dní")]), _vm.payload.note ? _c('p', {
    staticClass: "campaign-period"
  }, [_vm._v(_vm._s(_vm.payload.note))]) : _vm._e(), _vm.payload.clients.length ? _c('ul', {
    staticClass: "campaign-clients"
  }, _vm._l(_vm.payload.clients, function (client) {
    return _c('li', {
      key: client.id
    }, [_c('button', {
      staticClass: "campaign-client",
      attrs: {
        "type": "button",
        "disabled": !client.user_id,
        "aria-label": 'Otvoriť klienta ' + client.name
      },
      on: {
        "click": function click($event) {
          return _vm.openClient(client);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(client.name))]), _c('span', [_vm._v(_vm._s((client.property_locations || []).join('; ') || 'Lokácia nehnuteľnosti nie je vyplnená'))]), client.user_id ? _c('small', [_vm._v("Otvoriť klienta →")]) : _vm._e()])]);
  }), 0) : _c('p', {
    staticClass: "campaign-period"
  }, [_vm._v(_vm._s(_vm.payload.emptyMessage || 'V tomto období nemá kampaň žiadne registrácie.'))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }